
import React from "react"


import { useQuery } from "@tanstack/react-query"
import { supabase } from "@/integrations/supabase/client"
import { useAuth } from "./useAuth"

export const useCondominium = () => {
  const { profile } = useAuth()
  
  return useQuery({
    queryKey: ["condominium", profile?.condominium_id],
    queryFn: async () => {
      if (!profile?.condominium_id) {
        console.log("Usuário sem condomínio associado")
        return null
      }

      console.log("Buscando dados do condomínio:", profile.condominium_id)

      const { data, error } = await supabase
        .from("condominiums")
        .select("*")
        .eq("id", profile.condominium_id)
        .single()

      if (error) {
        console.error("Erro ao buscar condomínio:", error)
        throw error
      }

      console.log("Dados do condomínio encontrados:", data)
      return data
    },
    enabled: !!profile?.condominium_id
  })
}
